import React, { useContext, useEffect } from "react";
import Flex from "../../../UI/Flex";
import { JUSTIFY_CONTENT } from "../../../entities/Flex";
import { ButtonStyledWidth } from "../../../entities/Button";
import { getValueForKey } from "../../../context/translationsUtils";
import { TranslationContextInterface } from "../../../entities/Language";
import { TranslationContext } from "../../../context/TranslationContext";
import Button from "../../../UI/Button";
import { useSelector } from "react-redux";
import { getTenantCredentials } from "../../Tenant/selectors";
import {
  CreateMixPlatformInterface,
  TenantCredentialsInterface,
} from "../../../entities/Tenant";
import { getDataFromMixture } from "../../Mixture/selectors";
import { onOpenModal } from "../../Modal/slice/ModalSlice";
import { MODAL_TYPES } from "../../../entities/Modal";

import {
  getCalculationError,
  getCalculationLoading,
  getInitialCalculationIsCompleted,
} from "../../Calculation/slice/selectors";
import { useAppDispatch } from "../../../store/store";
import { useNavigate } from "react-router-dom";
import { WebConfiguratorPath } from "../../../routes/routes";
import { TEST_ID } from "../../../shared/testid";
import { isCheckoutHandlerDisabled } from "../../../utils/isCheckoutHandlerDisabled";
import { setNameHasError } from "../../Mixture/MixtureSlice";

const CheckoutHandler: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { translations }: TranslationContextInterface =
    useContext(TranslationContext);

  const credentials = useSelector(
    getTenantCredentials,
  ) as TenantCredentialsInterface;
  const token = credentials.token || "";

  const {
    selectedWeight,
    jars,
    name,
    condiments,
    mixtureOption,
    totalPercentage,
  } = useSelector(getDataFromMixture);

  const calculationError = useSelector(getCalculationError);
  const isLoadingCalculation = useSelector(getCalculationLoading);
  const initialCalculationIsCompleted = useSelector(
    getInitialCalculationIsCompleted,
  );

  useEffect(() => {
    if (calculationError) {
      dispatch(
        onOpenModal({
          modalType: MODAL_TYPES.ALERT,
          content: {
            name: getValueForKey(
              translations,
              `error_title.${calculationError.reasonCode}`,
              {},
              true,
            ),
            description: getValueForKey(
              translations,
              `error_description.${calculationError.reasonCode}`,
              {},
              true,
            ),
          },
        }),
      );
    }
  }, [calculationError, dispatch, translations]);

  const onHandleCheckout = () => {
    if (!name) {
      dispatch(setNameHasError(true));
      return;
    }

    const condimentsForPayload = condiments.map((item) => ({
      id: item.id,
      parts: item.meta.parts,
      percentage: item.meta.percentage,
      weight: item.meta.grams,
    }));

    const payload: CreateMixPlatformInterface = {
      name,
      weight: selectedWeight,
      categoryId: 3,
      condiments: condimentsForPayload,
      numberOfGlasses: jars,
      token,
      receipeType: mixtureOption,
    };

    dispatch(
      onOpenModal({
        modalType: MODAL_TYPES.CONFIRMATION,
        content: {
          name: credentials.tenant.name,
          description: getValueForKey(
            translations,
            "alerts.redirect_happening",
          ),
          tenantName: credentials.tenant.name,
          createMixPayload: payload,
        },
      }),
    );
  };
  return (
    <Flex
      styles={{
        justify: JUSTIFY_CONTENT.SPACE_BETWEEN,
      }}
    >
      <Button
        name={getValueForKey(translations, "edit_mix.delete")}
        styles={{
          width: ButtonStyledWidth.FULL,
          $margin: "0 20px 0 0",
        }}
        testid={TEST_ID.CREATE_MIX.DELETE_BUTTON}
        disabled={!!calculationError || isLoadingCalculation}
        onClick={() => navigate(WebConfiguratorPath.CUSTOM)}
        className="transparent"
      />
      <Button
        styles={{
          width: ButtonStyledWidth.FULL,
        }}
        testid={TEST_ID.CREATE_MIX.CONTINUE_BUTTON}
        disabled={isCheckoutHandlerDisabled(
          !!calculationError,
          isLoadingCalculation,
          mixtureOption,
          totalPercentage,
          initialCalculationIsCompleted,
        )}
        name={getValueForKey(translations, "edit_mix.continue")}
        onClick={() => onHandleCheckout()}
      />
    </Flex>
  );
};

export default CheckoutHandler;
